import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Project, Province } from "@/types";

interface ProjectState {
  projects: Project[];
  activeProjectId: string | null;
  createProject: (name: string, province: Province | null) => Project;
  setActiveProject: (id: string) => void;
}

// Non-PII project records; safe to persist in localStorage.
export const useProjectStore = create<ProjectState>()(
  persist(
    (set) => ({
      projects: [],
      activeProjectId: null,
      createProject: (name, province) => {
        const project: Project = {
          id: `prj_${crypto.randomUUID().slice(0, 8)}`,
          name,
          province,
          createdAt: new Date().toISOString(),
        };
        set((s) => ({ projects: [project, ...s.projects], activeProjectId: project.id }));
        return project;
      },
      setActiveProject: (id) => set({ activeProjectId: id }),
    }),
    { name: "buildease.projects" },
  ),
);

export const selectActiveProject = (s: ProjectState) =>
  s.projects.find((p) => p.id === s.activeProjectId) ?? null;
